import WeeklyLeaderBoard from './WeeklyLeaderBoard';

export default WeeklyLeaderBoard